import {
  ComplianceControlChecks,
  ComplianceControlChecksProps,
} from "~/pages/compliance/Control/ControlOutlets";

const FrameworkControlChecksEntryPage = ({}: ComplianceControlChecksProps) => {
  return <ComplianceControlChecks />;
};

export default FrameworkControlChecksEntryPage;
